import { PayloadAction } from "@reduxjs/toolkit";
import { editorInterface } from "../slice/editor";
import { Alert } from "../../@types/data";

/**
 * Updates the current data within the editor state.
 */
export const updateCurrentData = (state: editorInterface, action: PayloadAction<editorInterface["currentData"]>) => {
  state.currentData = {...state.currentData, ...action.payload}
};

/**
 * Updates the existing data within the editor state.
 */
export const updateExistingData = (state: editorInterface, action: PayloadAction<editorInterface["existingData"]>) => {
  if (action.payload && action.payload.data) {
    state.existingData = { ...state.existingData, ...action.payload, isCreated: false };
  } 
};

export const updateExistingDataCreating = (state: editorInterface, action: PayloadAction<boolean>) => {
    if (state.existingData) {
        state.existingData.isCreated = action.payload;
    }
};

export const updateActualMaxSizes = (state: editorInterface, action: PayloadAction<editorInterface["maxSizes"]>) => {
  state.maxSizes = action.payload
};

export const updateCurrentDataFabricArray = (state: editorInterface, action: PayloadAction<{layoutId: number, fabricElements: string}>) => {
  if (!state.currentData.layoutData.find((item) => item.id === action.payload.layoutId)) {
    return;
  }
  if(JSON.parse(action.payload.fabricElements).objects.length > 0) state.currentData.layoutData.find((item) => item.id === action.payload.layoutId)!.fabricElements = action.payload.fabricElements;
};

export const addLayoutData = (state: editorInterface, action: PayloadAction<editorInterface["layouts"]>) => {
  state.layouts = action.payload;
};

export const addCurrentDataLayoutData = (
  state: editorInterface,
  action: PayloadAction<{
    id: number;
    disabled: string[];
    enabled: string[];
    borderRadius: number;
    fabricElements: string;
  }>
) => {
  const layoutIndex = state.currentData.layoutData.findIndex((item) => item.id === action.payload.id);

  if (layoutIndex !== -1) {
    // Mise à jour directe sur le state si le layout existe
    state.currentData.layoutData[layoutIndex] = action.payload;
  } else {
    // Ajout d'un nouveau layout si non existant
    state.currentData.layoutData.push(action.payload);
  }
};

export const updateBorderRadiusState = (state: editorInterface, action: PayloadAction<{id: number, borderRadius: number}>) => {
  const layoutIndex = state.currentData.layoutData.findIndex( ( item ) => item.id === action.payload.id );
  if ( layoutIndex !== -1 ) {
    state.currentData.layoutData[ layoutIndex ].borderRadius = action.payload.borderRadius;
  } else {
    console.error( "Layout not found" );
  }
  return state;
}

export const updateParamGeneral = (state: editorInterface, action: PayloadAction<editorInterface["currentData"]["paramGeneral"]>) => {
  state.currentData.paramGeneral = {...state.currentData.paramGeneral, ...action.payload};
};

export const updateIsExportable = (state: editorInterface, action: PayloadAction<boolean>) => {
  state.isExportable = action.payload;
};

// /**
//  * Updates the fetchedData property of the state with the payload from the action.
//  */
// export const updateFetchedData = (state: editorInterface, action: PayloadAction<editorInterface["fetchedData"]>) => {
//   state.fetchedData = action.payload;
// };


// /**
//  * Updates the list of too big font sizes in the editor state.
//  */
// export const updateTooBigFontSizes = (state: editorInterface, action: PayloadAction<editorInterface["tooBigFontSizes"]>) => {
//   state.tooBigFontSizes = action.payload;
// };

/**
 * Function to toggle the alert state in the editor.
 */
export const toggleAlert = (state: editorInterface, action: PayloadAction<Alert>) => {
  if (state.alert.find((item) => item.index === action.payload.index && item.layout === action.payload.layout)) {
    state.alert = state.alert.map((item) =>
      item.index === action.payload.index && item.layout === action.payload.layout ? action.payload : item
    );
  } else {
    state.alert.push(action.payload);
  }
};

/**
 * Toggles the state of the `qrCode` property in the editor interface.
 */
export const toggleQrCode = (state: editorInterface, action: PayloadAction<editorInterface["qrCode"]>) => {
  state.qrCode = action.payload;
};